module.exports = __webpack_public_path__ + "static/media/coin.c286d57b.ogg";